import { render, staticRenderFns } from "./RiskCheckCheckLog.vue?vue&type=template&id=424c2dc4&scoped=true"
import script from "./RiskCheckCheckLog.vue?vue&type=script&lang=js"
export * from "./RiskCheckCheckLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c2dc4",
  null
  
)

export default component.exports